import LanguageDetector from 'i18next-browser-languagedetector';
import i18n from 'i18next';
import en_US from './locales/en_US.json';
import zh_CN from './locales/zh_CN.json';

import { initReactI18next } from 'react-i18next';

// let lang = localStorage.getItem("language");
// if (!lang) {
//     lang = 'zh_CN';
//     localStorage.setItem("language", 'zh_CN');
// }
i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({

        resources: {
            // en_US: {
            //     translation: en_US,
            // },
            en: {
                translation: en_US,
            },
            zh_CN: {
                translation: zh_CN,
            },
        },
        fallbackLng: 'zh_CN', // 备用语言，若要加载的语言存在某个键值缺失，则用fallbackLng来代替
        debug: false,
        interpolation: {
            escapeValue: false,
        },
        // lng: "en_US",
        // lng: "zh_CN",
    });

export default i18n;